import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, BaasicCheckbox, Loader, SliderCheckBox, BaasicButton } from 'core/components';
import { CarrierServiceDeliveryDateAndRateOption, RateBadge } from 'core/components/select';
import { channelType } from 'common/constants';
import { observer } from 'mobx-react';
import _ from 'lodash';

const ChangeShippingTemplate = ({
	t,
	changeShippingViewStore,
	changeShippingViewStore: {
		loading,
		form,
		form: { onSubmit, submitting },
		openVoidActiveLabelConfirmModal,
		isFormDisabled,
		isSuperAdminOrganization,
		warehouseDropdownStore,
		carrierServiceDropdownStore,
		selectedItem,
		isBulkAction,
		isSellerCloudVendor,
		isExternalOrder
	},
}) => {
	if (loading || submitting) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('CHANGESHIPPINGVIEW.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicDropdown
					dropdownStore={warehouseDropdownStore}
					optionOverride={{
						Component: AvailableInventoryOptionOverride,
						shouldDisplayCallback: () => {
							return !isBulkAction && _.sumBy(selectedItem.fulfillmentOrderItems, 'quantity') == 1;
						},
					}}
					className="spc--bottom--sml flex--grow--1"
				/>
				<BaasicDropdown
					isDisabled={isSellerCloudVendor}
					dropdownStore={carrierServiceDropdownStore}
					optionOverride={{
						Component: CarrierServiceDeliveryDateAndRateOption,
						LeadingComponent: RateBadge,
						shouldDisplayCallback: () => {
							return !isBulkAction;
						},
					}}
					className="spc--bottom--sml flex--grow--1"
				/>
				{!isSuperAdminOrganization ? (
					<UseBuyShippingDisplay {...{ changeShippingViewStore, t }} />
				) : (
					<DeliverByDateDisplay {...{ changeShippingViewStore, t }} />
				)}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--bottom--sml"
					label="SAVE"
					type="button"
					onClick={openVoidActiveLabelConfirmModal}
					disabled={form.$('carrierServiceId').isEmpty || form.$('warehouseId').isEmpty || (isFormDisabled && !isBulkAction)}
				/>
			</div>
		</form>
	);
};

const UseBuyShippingDisplay = observer(props => {
	const {
		t,
		changeShippingViewStore,
		changeShippingViewStore: { isAllAmazon, carrierServiceDropdownStore, form, selectedItem, isBulkAction },
	} = props;
	const displayBuyShipping =
		_.get(selectedItem, 'order.channel.channelType.name') === channelType.amazon || isAllAmazon || _.get(selectedItem, 'order.channel.useAmazonBuyShipping');
	return (
		<React.Fragment>
			{displayBuyShipping ? (
				<div className="spc--bottom--sml">
					<BaasicCheckbox
						field={form.$('useBuyShipping')}
						onChangeCallback={async e => {
							changeShippingViewStore.suspend();
							form.$('ignoreDeliverByDate').set('value', !e.currentTarget.checked);
							await carrierServiceDropdownStore.updateFilter({
								useBuyShipping: e.currentTarget.checked,
								ignoreDeliverByDate: !e.currentTarget.checked,
							});
							changeShippingViewStore.resume();
						}}
					/>
				</div>
			) : (
				isBulkAction && <div className="spc--bottom--sml">{t('BUYSHIPPINGOPTIONDISABLED')}</div>
			)}
		</React.Fragment>
	);
});

const DeliverByDateDisplay = observer(props => {
	const {
		t,
		changeShippingViewStore: { form, onIgnoreDeliverByDateChange, selectedItem, selectedItems, isBulkAction },
	} = props;
	return (
		<div className="flex--primary spc--bottom--sml">
			<div className="spc--right--xsml">
				<SliderCheckBox field={form.$('ignoreDeliverByDate')} onChangeCallback={onIgnoreDeliverByDateChange} />
			</div>
			<div>
				<label className="type--wgt--bold type--color--text">{t('CHANGESHIPPINGVIEW.IGNOREDELIVERBYDATE')}</label>
				{((_.get(selectedItem, 'order.channel.channelType.name') === channelType.amazon || _.get(selectedItem, 'order.channel.useAmazonBuyShipping')) ||
					(isBulkAction && selectedItems.some(item => item.order.channel.channelType.name === channelType.amazon || item.order.channel.useAmazonBuyShipping))) && (
					<span className="display--b type--color--grey-5">{t('CHANGESHIPPINGVIEW.IGNOREDELIVERBYDATEFORAMAZON')}</span>
				)}
			</div>
		</div>
	);
});

const AvailableInventoryOptionOverride = observer(props => {
	const {
		data: { extra },
	} = props;
	return <div>{extra.unallocated}</div>;
});

export default defaultTemplate(ChangeShippingTemplate);
